import { Component } from '@angular/core';

@Component({
  selector: 'angular-community-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss'],
})
export class AboutComponent {}
